import { get, has } from "lodash";

import useFlags from "components/FeatureFlag/useFlags";

function useWelcomeToHublyFeature() {
  const { loadingConfig, flags } = useFlags();

  const ff = has(flags, "welcome-to-community-form")
    ? get(flags, "welcome-to-community-form")
    : {};

  return {
    loadingFeature: loadingConfig,
    welcomeForm: ff.forms?.welcomeToCommunity,
    schedulingWidget: ff.forms?.schedulingWidget,
  };
}

export default useWelcomeToHublyFeature;
